:root,
.uic-theme-responsive {
  --uxc-app-header-height: 52px;
  --uxc-app-header-expandables-y-offset: 56px;
  --uxc-app-header-expandables-min-width: 300px;
  --uxc-app-header-z-index: 400;
  --uxc-app-header-bg-color: var(--uic-color-blue5);
  --uxc-app-header-separator-color: var(--uic-color-white);
  --uxc-app-header-launcher-width: 68px;
}

@media only screen and (min-width: 1024px) {
  .uic-theme-responsive {
    --uxc-app-header-height: 68px;
    --uxc-app-header-expandables-y-offset: 72px;
    --uxc-app-header-launcher-width: 85px;
  }
}
:root,
.uic-theme-responsive {
  --uxc-app-toast-notifications-z-index: 350;
}

.uxc-app-notification-list {
  display: block;
}
.uxc-app-notification-list__cluster {
  display: block;
}
.uxc-app-notification-list__list {
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
}
.uxc-app-notification-list__list-header {
  padding: 15px 10px;
  position: sticky;
  left: 0;
  right: 0;
  top: -2px;
  width: auto;
  background-color: #fff;
  z-index: 1;
  font-weight: var(--ux-font-weight-bold, bold);
  border-bottom: 1px solid rgb(161, 161, 161);
}
.uxc-app-notification-list__list-footer {
  padding: 15px 10px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  min-height: 100px;
}
.uxc-app-notification-list__list-item {
  margin: 0;
  padding: 10px;
  list-style: none;
  border-bottom: 1px solid rgb(161, 161, 161);
}
.uxc-app-notification-list__load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.uxc-app-notification-list .ux-notification-item__headline, .uxc-app-notification-list .ux-notification-item__source {
  font-weight: var(--ux-font-weight-bold, bold);
}
.uxc-app-notification-list .ux-notification-item__source {
  text-transform: var(--ux-label-text-tranform, none);
}